import { render, staticRenderFns } from "./support-inactive.component.html?vue&type=template&id=bb46c8cc&scoped=true&external"
import script from "./support-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./support-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./support-inactive.component.scss?vue&type=style&index=0&id=bb46c8cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb46c8cc",
  null
  
)

export default component.exports